import { Box, styled } from '@mui/material'

export const StyledBannerSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  background: 'linear-gradient(270deg, #FBFCFF 0%, #EBF6FC 50.36%)',
  height: '62vh',

  [theme.breakpoints.up('md')]: {
    flex: 1,
    height: '618px',
  },
}))
